import {
  DateInput as RawDateInput,
  DateInputProps as RawDateInputProps,
} from '@mantine/dates';
import { useFormState } from 'components/elements/form';
import React from 'react';
import { useController } from 'react-hook-form';

export interface DateInputInputProps extends RawDateInputProps {
  type: 'date' | 'date-time';
  name: string;
}

export default function DateInputInput(props: DateInputInputProps) {
  const {
    onChange,
    disabled,
    readOnly,
    name,
    placeholder,
    type,
    error,
    ...rest
  } = props;
  const formState = useFormState();
  const { field, fieldState } = useController({
    name,
  });

  const _disabled = formState.editable === false || disabled || readOnly;
  const _error = fieldState.error?.message || error;

  const _placeholder = React.useMemo(() => {
    if (_disabled) return undefined;
    if (placeholder) return placeholder;
    switch (type) {
      case 'date':
        return 'DD/MM/YYYY';
      case 'date-time':
        return 'DD/MM/YYYY HH:mm';
    }
  }, [_disabled, placeholder, type]);

  const valueFormat = React.useMemo(() => {
    switch (type) {
      case 'date':
        return 'DD/MM/YYYY';
      case 'date-time':
        return 'DD/MM/YYYY HH:mm';
    }
  }, [type]);

  const withAsterisk = React.useMemo(() => {
    if (_disabled) return false;
    if (rest.required || rest.withAsterisk) return true;
  }, [_disabled, rest.required, rest.withAsterisk]);

  return (
    <RawDateInput
      {...rest}
      {...field}
      placeholder={_placeholder}
      value={field.value}
      onChange={(value) => {
        field.onChange(value);
        onChange?.(value);
      }}
      clearable
      rightSection={<></>}
      disabled={_disabled}
      error={_error}
      valueFormat={valueFormat}
      withAsterisk={withAsterisk}
    />
  );
}
